import { useEffect, useState, useRef, useMemo } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";
import { debounce } from "lodash";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// Table styling for better header visibility and fit to screen
const tableStyles = `
    #printableTable {
        font-size: 0.7rem;
        width: 100%;
        table-layout: fixed;
        margin-bottom: 0;
    }
    #printableTable thead th {
        font-size: 0.65rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        font-weight: 600;
        vertical-align: middle;
        line-height: 1.1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    #printableTable tbody td {
        font-size: 0.7rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .table-responsive {
        overflow-x: visible;
        width: 100%;
    }
    @media (min-width: 1400px) {
        #printableTable thead th {
            font-size: 0.7rem;
            padding: 6px 4px;
        }
        #printableTable tbody td {
            font-size: 0.75rem;
            padding: 6px 4px;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = tableStyles;
    document.head.appendChild(styleSheet);
}

export default function DueList() {
    const { http, user } = AuthUser();
    const location = useLocation();
    const [tasks, setTasks] = useState([]);
    // Check if user came from agent_report via location state or sessionStorage
    const isFromAgentReport = location.state?.fromAgentReport || sessionStorage.getItem('fromAgentReport') === 'true';
    
    // Clear the sessionStorage flag after checking
    useEffect(() => {
        if (sessionStorage.getItem('fromAgentReport') === 'true') {
            sessionStorage.removeItem('fromAgentReport');
        }
    }, []);
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [devision, setDevision] = useState([]);
    const [subject, setSubjects] = useState([]);
    const [year, setYear] = useState([]);
    const [term, setTerm] = useState([]);
    const [fees, setFeesList] = useState([]);
    const [standard, setstandard] = useState([]);
    const [selclass, setselclass] = useState("");
    const [allStudent, setAllStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState([]);
    const [showClassDropdown, setShowClassDropdown] = useState(false);
    const classDropdownRef = useRef(null);
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevYears, setselectedDevYears] = useState([]);
    const [showYearDropdown, setShowYearDropdown] = useState(false);
    const yearDropdownRef = useRef(null);
    const [selectedDevStudType, setselectedDevStudType] = useState([]);
    const [showFeesDropdown, setShowFeesDropdown] = useState(false);
    const feesDropdownRef = useRef(null);
    const [selectedDevStudAgentType, setselectedDevStudAgentType] = useState("");
    const [selectedDevStudTypeStd, setselectedDevStudTypeStd] = useState("");
    const [selectedFeesStud, setselectedFeesStud] = useState("");
    const [amount, setAmount] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [dueDateEnd, setDueDateEnd] = useState("");
    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [stYear, setstYear] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stAgent, setstAgent] = useState([]);
    const [agentTotals, setAgentTotals] = useState({});
    const [agentNames, setAgentNames] = useState({});
    const [companyInfo, setCompanyInfo] = useState(null);

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });

        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        http.get(`/year`).then((res) => {
            setstYear(res.data.data);
        });

        http.get(`/subject?login_user=${user.id}`).then((res) => {
            setSubjects(res.data.data);
        });

        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });

        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
            // Create a map of agent ID to agent name
            const agentMap = {};
            res.data.data.forEach(agent => {
                agentMap[agent.id] = agent.name;
            });
            setAgentNames(agentMap);
        });

        http.get(`/devision?login_user=${user.id}`).then((res) => {
            setDevision(res.data.data);
        });

        http.get(`/terms?login_user=${user.id}`).then((res) => {
            setTerm(res.data.data);
        });

        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setstandard(res.data.data);
        });

        http.get(`/year?login_user=${user.id}`).then((res) => {
            setYear(res.data.data);
        });

        http.get(`/companyinfo?login_user=${user.id}`).then((res) => {
            if (res.data.data && res.data.data.length > 0) {
                setCompanyInfo(res.data.data[0]);
            }
        });

        // Default fees list (all years) until year filter is applied
        http.get(`/tution_feeslist?company_id=${user.company_id}`).then((res) => {
            setFeesList(res.data.data || []);
        });
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (feesDropdownRef.current && !feesDropdownRef.current.contains(e.target)) {
                setShowFeesDropdown(false);
            }
            if (yearDropdownRef.current && !yearDropdownRef.current.contains(e.target)) {
                setShowYearDropdown(false);
            }
            if (classDropdownRef.current && !classDropdownRef.current.contains(e.target)) {
                setShowClassDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleFilter = () => {
        const valueToSet = selectedStud ? selectedStud.value : " ";
        const classParam = Array.isArray(selectedClassStud)
            ? selectedClassStud.join(",")
            : selectedClassStud;
        fetchTaskDetails(
            classParam,
            selectedDevStud,
            dueDate,
            dueDateEnd,
            selectedDevStudType.join(','),
            valueToSet,
            selectedDevStudTypeStd,
            selectedDevStudAgentType
        );
    };


    const fetchTaskDetails = (selectedClassStuds, selectedDevStuds, dueDates, dueDateEnds, typePay, student, std_type, agent) => {
        setIsLoading(true);
        //  const fetchTaskDetailsDebounced = debounce(fetchTaskDetails, 500);
        let endpoint = `/student_annual_fee_sub_due?class=${encodeURIComponent(selectedClassStuds || "")}&dev=${selectedDevStuds}&start_date=${dueDates}&end_date=${dueDateEnds}&type=${typePay}&student=${student}&company_id=${user.company_id}&std_type=${std_type}&agent=${agent}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
                // Store agent totals if provided
                if (res.data.agent_totals) {
                    setAgentTotals(res.data.agent_totals);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };


    const handleToggleClass = (className) => {
        setselectedClassStud((prev) =>
            prev.includes(className)
                ? prev.filter((c) => c !== className)
                : [...prev, className]
        );
    };

    const handleSelectAllClasses = () => {
        const names = classOptionsForYear.map((c) => c.class_name);
        setselectedClassStud((prev) =>
            names.length > 0 && prev.length === names.length ? [] : names
        );
    };

    const handleSelectChangeDev = (event) => {
        setselectedDevStud(event.target.value);
    };


    const handleSelectChangeStdType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };



    // Classes linked to year via standard.ext_3 (same as Student Add/Edit)
    // No year selected → all classes; one or more years → union of those years' classes
    const classOptionsForYear = useMemo(() => {
        if (!selectedDevYears.length) {
            return stClass;
        }
        return stClass.filter((cls) => selectedDevYears.includes(cls.ext_3));
    }, [stClass, selectedDevYears]);

    const loadFeesForYears = (years) => {
        setselectedClassStud([]);
        setselectedDevStudType([]);

        if (!years.length) {
            // Optional year filter: show all fees types when none selected
            http.get(`/tution_feeslist?company_id=${user.company_id}`)
                .then((res) => {
                    setFeesList(res.data.data || []);
                    setLoading(false);
                })
                .catch(() => {
                    setFeesList([]);
                    setLoading(false);
                });
            return;
        }

        setLoading(true);
        Promise.all(
            years.map((yearVal) =>
                http.get(`/tution_feeslists?company_id=${user.company_id}&year=${yearVal}`)
            )
        )
            .then((responses) => {
                const byId = new Map();
                responses.forEach((res) => {
                    (res.data.data || []).forEach((fee) => {
                        byId.set(fee.id, fee);
                    });
                });
                setFeesList(Array.from(byId.values()));
                setLoading(false);
            })
            .catch(() => {
                setFeesList([]);
                setLoading(false);
            });
    };

    const handleToggleYear = (yearName) => {
        const next = selectedDevYears.includes(yearName)
            ? selectedDevYears.filter((y) => y !== yearName)
            : [...selectedDevYears, yearName];
        setselectedDevYears(next);
        loadFeesForYears(next);
    };

    const handleSelectAllYears = () => {
        const allNames = stYear.map((y) => y.name);
        const next =
            selectedDevYears.length === allNames.length ? [] : allNames;
        setselectedDevYears(next);
        loadFeesForYears(next);
    };



    const handleToggleFeeType = (feeId) => {
        setselectedDevStudType(prev => {
            if (prev.includes(feeId)) {
                return prev.filter(id => id !== feeId);
            }
            return [...prev, feeId];
        });
    };

    const handleSelectAllFeeTypes = () => {
        if (selectedDevStudType.length === fees.length) {
            setselectedDevStudType([]);
        } else {
            setselectedDevStudType(fees.map(f => String(f.id)));
        }
    };

    const handleSelectChangeAgentType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };
    console.log('dueRepo', tasks);

    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const initialState = {
        name: "",
    };

    const deleteTask = async (taskId) => {
        await http
            .delete(`/departments_del/${taskId}`)
            .then((response) => {
                toast.success("Departments Deleted successfully !");
                fetchTaskDetails();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };

    const options = allStudent.map((user) => ({
        value: user.id,
        label: `${user.adm_no} - ${user.ext_2}${user.ext_3} - ${user.class}${user.section}  - ${user.mobile}`,
    }));

    const handleClearFields = () => {
        window.location.reload();
    };

    const handleSubmit = async () => {
        if (tasks.length === 0 || !selectedFeesStud) {
            toast.error("Please select a student and fees type before submitting.");
            return true;
        }

        if (tasks.length === 0 || !selectedFeesStud || !amount || !dueDate) {
            toast.error("Please enter due date and amount");
            return;
        }


        try {
            const promises = [];

            for (let i = 0; i < tasks.length; i++) {
                const task = tasks[i];

                const formData = {
                    admn_no: task.admn_no,
                    ext_1: task.roll_no,
                    first_name: task.ext_2,
                    last_name: task.ext_3,
                    class: task.class,
                    dev: task.section,
                    fees_id: selectedFeesStud,
                    student_id: task.id,
                    amount: amount,
                    ext_5: dueDate,
                };

                // Push the promise for each API call to the array
                promises.push(http.post('/annual_fees', formData));
            }

            // Wait for all promises to be resolved
            await Promise.all(promises);

            // If all promises are resolved, show success toast
            toast.success("Fees data updated successfully");
            fetchTaskDetails(selectedStud, selectedClassStud, selectedDevStud, selectedFeesStud);

        } catch (error) {
            console.error("Error submitting tasks:", error);
        }
    };
    function handleSelectChangeFees(event) {
        setselectedFeesStud(event.target.value);
    }

    function handleChangeAmount(event) {
        setAmount(event.target.value)
    }

    function handleChangeDate(event) {
        setDueDate(event.target.value)
    }


    function handleChangeDateEnd(event) {
        setDueDateEnd(event.target.value)
    }


    const convertToExcel = () => {
        const sortedTasks = [...tasks].sort((a, b) => {
            const classCompare = String(a.class || '').localeCompare(String(b.class || ''), undefined, { numeric: true });
            if (classCompare !== 0) return classCompare;
            return String(a.dev || '').localeCompare(String(b.dev || ''), undefined, { numeric: true });
        });

        const filteredTasks = sortedTasks.map(task => {
            const { ext_1, ext_2, ext_3, fees_id, student_id, ext_6, method, reff, ext_8, ext_9, created_at, updated_at, ext_10, ...filteredTask } = task;

            filteredTask.due = calculateDue(task.amount, task.ext_6);

            if (task.fees_name) {
                filteredTask.fees_name = task.fees_name.name;
            }

            if (task.ext_6) {
                filteredTask.paid_amount = task.ext_6;
            }

            if (task.amount) {
                filteredTask.master_amount = task.amount;
            }

            return filteredTask;
        });

        const ws = XLSX.utils.json_to_sheet(filteredTasks);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Student_Due_List");
        XLSX.writeFile(wb, "student_due_list.xlsx");
    };

    const totalSum = tasks.reduce((total, task) => {
        return total + parseFloat(task.amount) - parseFloat(task.ext_6 || 0);
    }, 0);

    const totalSumPaid = tasks.reduce((total, task) => {
        return total + parseFloat(task.ext_6 || 0);
    }, 0);

    const totalSumMaster = tasks.reduce((total, task) => {
        return total + parseFloat(task.amount || 0);
    }, 0);


    const handlePrint = () => {
        const content = `
            <html>
            <head>
                <title>Print Table</title>
                <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td {
                        border: 1px solid black;
                        padding: 8px;
                        text-align: left;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                </style>
            </head>
            <body>
                <table>
                    <thead>
                        <tr>
                            <th className="text-danger">No</th>
                            <th>Adm No</th>
                            <th>Student Name</th>
                            <th>Class</th>
                            <th>Division</th>
                            <th>Fee Type</th>
                            <th>Due Date</th>
                            <th>Type</th>
                            <th>Amount(Due)</th>
                            <th>Amount Paid</th>
                            <th>Amount Master</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tasks.map((task, index) => {
            const dueAmount = calculateDue(task.amount, task.ext_6);
            return `
                                <tr key=${index}>
                                    <td>${index + 1}</td>
                                    <td>${task.admn_no}</td>
                                    <td>${task.first_name} ${task.last_name}</td>
                                    <td>${task.class}</td>
                                    <td>${task.dev}</td>
                                    <td>${task.fees_name ? task.fees_name.name : ""}</td>
                                    <td>${task.ext_5}</td>
                                    <td>${task.std_type}</td>
                                    <td><b>${dueAmount}</b></td>
                                    <td><b>${task.ext_6}</b></td> 
                                    <td><b>${task.amount}</b></td>
                                </tr>
                            `;
        }).join('')}
                    </tbody>
                </table>
            </body>
            </html>
        `;


        const printWindow = window.open('', '', 'height=500, width=500');
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.print();
    };

    const calculateDue = (amount, ext_6) => {
        const due = amount - ext_6;
        return due;
    };

    // Format number without .00 if it's a whole number, and remove trailing zeros
    const formatNumber = (num) => {
        if (num === null || num === undefined || num === '') return '';
        const numValue = parseFloat(num);
        if (isNaN(numValue)) return '';
        // Format with commas and remove trailing zeros and decimal point if not needed
        return numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\.?0+$/, '');
    };

    const formatIndian = (num) => {
        const n = parseFloat(num) || 0;
        if (n === 0) return '';
        return n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    };

    const convertToPDF = (excludeZero = false) => {
        const doc = new jsPDF('l', 'mm', 'a4');
        const pageW = doc.internal.pageSize.getWidth();

        const groupedData = {};
        const feeTypes = new Set();
        const feeTypeTotals = {};

        tasks.forEach(task => {
            const key = `${task.admn_no}-${task.student_id}`;
            const feeTypeName = task.fees_name ? task.fees_name.name : 'Unknown';

            if (!groupedData[key]) {
                groupedData[key] = {
                    admn_no: task.admn_no,
                    first_name: task.first_name,
                    last_name: task.last_name,
                    class: task.class,
                    dev: task.dev,
                    fees: {}
                };
            }

            const dueAmount = calculateDue(task.amount, task.ext_6);
            groupedData[key].fees[feeTypeName] = {
                due: dueAmount,
                paid: parseFloat(task.ext_6) || 0,
                master: parseFloat(task.amount) || 0
            };

            feeTypes.add(feeTypeName);
            if (!feeTypeTotals[feeTypeName]) feeTypeTotals[feeTypeName] = 0;
            feeTypeTotals[feeTypeName] += dueAmount;
        });

        const feeTypeArray = Array.from(feeTypes).sort();
        let studentsArray = Object.values(groupedData);

        studentsArray.sort((a, b) => {
            const c = String(a.class || '').localeCompare(String(b.class || ''), undefined, { numeric: true });
            return c !== 0 ? c : String(a.dev || '').localeCompare(String(b.dev || ''), undefined, { numeric: true });
        });

        if (excludeZero) {
            studentsArray = studentsArray.filter(student => {
                let gt = 0;
                feeTypeArray.forEach(ft => { if (student.fees[ft]) gt += student.fees[ft].due; });
                return gt > 0;
            });
        }

        // Shorter fee headers (totals stay in footer) so class/name columns stay readable
        const shortenFeeHeader = (name) => {
            if (!name) return '';
            return String(name)
                .replace(/\s*-\s*/g, ' - ')
                .replace(/\s+/g, ' ')
                .trim();
        };

        const headers = ['#', 'Class', 'Div', 'Adm No', 'Student Name'];
        feeTypeArray.forEach((ft) => {
            headers.push(shortenFeeHeader(ft));
        });
        headers.push('Grand Total');

        const rows = studentsArray.map((student, idx) => {
            const fullName = `${student.first_name || ''} ${student.last_name || ''}`.trim();
            // Keep class as one readable string (avoid mid-word breaks from tiny columns)
            const classLabel = String(student.class || '').replace(/\s+/g, ' ').trim();
            const row = [idx + 1, classLabel, student.dev || '', student.admn_no || '', fullName];
            let grandTotal = 0;

            feeTypeArray.forEach(ft => {
                const fd = student.fees[ft];
                if (fd) {
                    row.push(formatIndian(fd.due));
                    grandTotal += fd.due;
                } else {
                    row.push('');
                }
            });
            row.push(formatIndian(grandTotal));
            return row;
        });

        // Totals footer row
        let overallGrandTotal = 0;
        const footerRow = ['', '', '', '', 'TOTAL'];
        feeTypeArray.forEach(ft => {
            const t = feeTypeTotals[ft] || 0;
            overallGrandTotal += t;
            footerRow.push(formatIndian(t));
        });
        footerRow.push(formatIndian(overallGrandTotal));

        // --- Header Section ---
        let y = 10;
        if (companyInfo && companyInfo.company_name) {
            doc.setFontSize(16);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(33, 37, 41);
            doc.text(companyInfo.company_name.toUpperCase(), pageW / 2, y, { align: 'center' });
            y += 6;
        }
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(60, 60, 60);
        doc.text('Sum of Due - Fee Report', pageW / 2, y, { align: 'center' });
        y += 4;

        doc.setDrawColor(52, 73, 94);
        doc.setLineWidth(0.6);
        doc.line(8, y, pageW - 8, y);
        y += 5;

        // Filter info
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(80, 80, 80);
        let filterParts = [];
        if (Array.isArray(selectedClassStud) && selectedClassStud.length > 0) {
            filterParts.push(`Class: ${selectedClassStud.join(", ")}`);
        }
        if (selectedDevStud) filterParts.push(`Div: ${selectedDevStud}`);
        if (dueDate) filterParts.push(`From: ${moment(dueDate).format('DD-MM-YYYY')}`);
        if (dueDateEnd) filterParts.push(`To: ${moment(dueDateEnd).format('DD-MM-YYYY')}`);
        if (excludeZero) filterParts.push('[Excluding Zero Due]');
        if (filterParts.length > 0) {
            doc.text(filterParts.join('  |  '), 8, y);
        }
        doc.text(`Generated on: ${moment().format('DD-MM-YYYY HH:mm')}`, pageW - 8, y, { align: 'right' });
        if (filterParts.length > 0) y += 4;
        y += 2;

        // --- Column widths (wider Class / Name so text does not break mid-word) ---
        const feeCount = feeTypeArray.length;
        const marginX = 8;
        const usableW = pageW - marginX * 2;
        // Scale fixed columns down slightly when many fee types
        const classW = feeCount > 6 ? 26 : 32;
        const nameW = feeCount > 6 ? 28 : 34;
        const fixedCols = {
            0: 7,          // #
            1: classW,     // Class
            2: 8,          // Div
            3: 16,         // Adm No
            4: nameW,      // Student Name
        };
        const fixedTotal = Object.values(fixedCols).reduce((a, b) => a + b, 0);
        const dynamicCount = feeCount + 1; // fee cols + grand total
        const dynamicColW = Math.max(14, (usableW - fixedTotal) / dynamicCount);

        const colStyles = {
            0: { cellWidth: fixedCols[0], halign: 'center', valign: 'middle' },
            1: { cellWidth: fixedCols[1], halign: 'left', valign: 'middle', overflow: 'linebreak' },
            2: { cellWidth: fixedCols[2], halign: 'center', valign: 'middle' },
            3: { cellWidth: fixedCols[3], halign: 'left', valign: 'middle' },
            4: { cellWidth: fixedCols[4], halign: 'left', valign: 'middle', overflow: 'linebreak' },
        };
        for (let i = 0; i < dynamicCount; i++) {
            const idx = 5 + i;
            colStyles[idx] = {
                cellWidth: dynamicColW,
                halign: 'right',
                valign: 'middle',
            };
        }

        autoTable(doc, {
            head: [headers],
            body: rows,
            foot: [footerRow],
            startY: y,
            theme: 'grid',
            tableWidth: usableW,
            margin: { left: marginX, right: marginX },
            styles: {
                fontSize: feeCount > 6 ? 6.5 : 7,
                cellPadding: { top: 1.5, right: 1.5, bottom: 1.5, left: 1.5 },
                lineColor: [189, 195, 199],
                lineWidth: 0.2,
                textColor: [44, 62, 80],
                overflow: 'linebreak',
                valign: 'middle',
            },
            headStyles: {
                fillColor: [44, 62, 80],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle',
                fontSize: feeCount > 6 ? 5.5 : 6.5,
                cellPadding: { top: 2, right: 1.2, bottom: 2, left: 1.2 },
                overflow: 'linebreak',
            },
            footStyles: {
                fillColor: [236, 240, 241],
                textColor: [44, 62, 80],
                fontStyle: 'bold',
                fontSize: 7,
                valign: 'middle',
            },
            alternateRowStyles: {
                fillColor: [248, 249, 250],
            },
            columnStyles: colStyles,
            didParseCell: function(data) {
                // Fee amount columns + grand total: right align
                if (data.column.index > 4) {
                    data.cell.styles.halign = 'right';
                }
                // Class / Adm / Name: left
                if (data.column.index === 1 || data.column.index === 3 || data.column.index === 4) {
                    if (data.section === 'body') {
                        data.cell.styles.halign = 'left';
                    }
                }
                if (data.column.index === data.table.columns.length - 1) {
                    if (data.section === 'body') {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.textColor = [39, 174, 96];
                    }
                }
                if (data.section === 'foot' && data.column.index === 4) {
                    data.cell.styles.halign = 'right';
                    data.cell.styles.fontStyle = 'bold';
                }
                // Header fee names: allow wrap, keep centered
                if (data.section === 'head' && data.column.index > 4) {
                    data.cell.styles.halign = 'center';
                    data.cell.styles.valign = 'middle';
                }
            },
            didDrawPage: function () {
                const pageCount = doc.internal.getNumberOfPages();
                const pageH = doc.internal.pageSize.getHeight();
                doc.setFontSize(7);
                doc.setTextColor(150);
                doc.text(
                    `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
                    pageW / 2, pageH - 7,
                    { align: 'center' }
                );
            }
        });

        const filename = excludeZero
            ? `due_list_exclude_zero_${moment().format('YYYY-MM-DD')}.pdf`
            : `due_list_${moment().format('YYYY-MM-DD')}.pdf`;
        doc.save(filename);
        toast.success('PDF exported successfully!');
    };
    
    // Separate function for exclude zero PDF
    const convertToPDFExcludeZero = () => {
        convertToPDF(true);
    };

    const convertToExcelStyled = (excludeZero = false) => {
        const groupedData = {};
        const feeTypes = new Set();
        const feeTypeTotals = {};

        tasks.forEach(task => {
            const key = `${task.admn_no}-${task.student_id}`;
            const feeTypeName = task.fees_name ? task.fees_name.name : 'Unknown';
            if (!groupedData[key]) {
                groupedData[key] = {
                    admn_no: task.admn_no, first_name: task.first_name,
                    last_name: task.last_name, class: task.class, dev: task.dev, fees: {}
                };
            }
            const dueAmount = calculateDue(task.amount, task.ext_6);
            groupedData[key].fees[feeTypeName] = { due: dueAmount };
            feeTypes.add(feeTypeName);
            if (!feeTypeTotals[feeTypeName]) feeTypeTotals[feeTypeName] = 0;
            feeTypeTotals[feeTypeName] += dueAmount;
        });

        const feeTypeArray = Array.from(feeTypes).sort();
        let studentsArray = Object.values(groupedData);
        studentsArray.sort((a, b) => {
            const c = String(a.class || '').localeCompare(String(b.class || ''), undefined, { numeric: true });
            return c !== 0 ? c : String(a.dev || '').localeCompare(String(b.dev || ''), undefined, { numeric: true });
        });
        if (excludeZero) {
            studentsArray = studentsArray.filter(s => {
                let gt = 0;
                feeTypeArray.forEach(ft => { if (s.fees[ft]) gt += s.fees[ft].due; });
                return gt > 0;
            });
        }

        const fmtNum = (n) => { const v = parseFloat(n) || 0; return v === 0 ? '' : v.toLocaleString('en-IN', { maximumFractionDigits: 0 }); };
        let overallTotal = 0;
        feeTypeArray.forEach(ft => overallTotal += (feeTypeTotals[ft] || 0));

        const filterParts = [];
        if (Array.isArray(selectedClassStud) && selectedClassStud.length > 0) {
            filterParts.push(`Class: ${selectedClassStud.join(", ")}`);
        }
        if (selectedDevStud) filterParts.push(`Div: ${selectedDevStud}`);
        if (dueDate) filterParts.push(`From: ${moment(dueDate).format('DD-MM-YYYY')}`);
        if (dueDateEnd) filterParts.push(`To: ${moment(dueDateEnd).format('DD-MM-YYYY')}`);
        if (excludeZero) filterParts.push('[Excluding Zero Due]');

        const totalCols = 5 + feeTypeArray.length + 1;
        const thStyle = 'background:#2C3E50;color:#fff;font-weight:bold;text-align:center;padding:6px 8px;border:1px solid #95a5a6;font-size:11px;';
        const tdStyle = 'padding:4px 8px;border:1px solid #dee2e6;font-size:10px;';
        const numStyle = `${tdStyle}text-align:right;`;
        const altBg = 'background:#f8f9fa;';
        const footStyle = 'background:#ecf0f1;font-weight:bold;padding:6px 8px;border:1px solid #95a5a6;font-size:11px;';

        let html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head><meta charset="utf-8">
        <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>Due Report</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
        </x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body><table>`;

        // Company name
        if (companyInfo && companyInfo.company_name) {
            html += `<tr><td colspan="${totalCols}" style="text-align:center;font-size:16px;font-weight:bold;padding:8px;color:#212529;">${companyInfo.company_name.toUpperCase()}</td></tr>`;
        }
        html += `<tr><td colspan="${totalCols}" style="text-align:center;font-size:13px;font-weight:bold;padding:4px;color:#3c3c3c;">Sum of Due - Fee Report</td></tr>`;

        // Filter + date row
        html += `<tr><td colspan="${Math.ceil(totalCols / 2)}" style="font-size:9px;color:#505050;padding:4px;">${filterParts.join('  |  ')}</td>`;
        html += `<td colspan="${totalCols - Math.ceil(totalCols / 2)}" style="font-size:9px;color:#505050;padding:4px;text-align:right;">Generated on: ${moment().format('DD-MM-YYYY HH:mm')}</td></tr>`;
        html += `<tr><td colspan="${totalCols}" style="padding:2px;"></td></tr>`;

        // Header row
        html += `<tr><td style="${thStyle}">#</td><td style="${thStyle}">Class</td><td style="${thStyle}">Div</td><td style="${thStyle}">Adm No</td><td style="${thStyle}">Student Name</td>`;
        feeTypeArray.forEach(ft => {
            const t = feeTypeTotals[ft] || 0;
            html += `<td style="${thStyle}">${ft}<br/>(${fmtNum(t)})</td>`;
        });
        html += `<td style="${thStyle}">Grand Total</td></tr>`;

        // Data rows
        studentsArray.forEach((student, idx) => {
            const bg = idx % 2 === 1 ? altBg : '';
            const fullName = `${student.first_name || ''} ${student.last_name || ''}`.trim();
            let grandTotal = 0;

            html += `<tr>`;
            html += `<td style="${tdStyle}text-align:center;${bg}">${idx + 1}</td>`;
            html += `<td style="${tdStyle}text-align:center;${bg}">${student.class}</td>`;
            html += `<td style="${tdStyle}text-align:center;${bg}">${student.dev}</td>`;
            html += `<td style="${tdStyle}${bg}">${student.admn_no}</td>`;
            html += `<td style="${tdStyle}${bg}">${fullName}</td>`;

            feeTypeArray.forEach(ft => {
                const fd = student.fees[ft];
                const val = fd ? fd.due : 0;
                grandTotal += val;
                html += `<td style="${numStyle}${bg}">${fmtNum(val)}</td>`;
            });
            html += `<td style="${numStyle}font-weight:bold;color:#27ae60;${bg}">${fmtNum(grandTotal)}</td>`;
            html += `</tr>`;
        });

        // Footer total row
        html += `<tr><td colspan="5" style="${footStyle}text-align:right;">TOTAL</td>`;
        feeTypeArray.forEach(ft => {
            html += `<td style="${footStyle}text-align:right;">${fmtNum(feeTypeTotals[ft] || 0)}</td>`;
        });
        html += `<td style="${footStyle}text-align:right;">${fmtNum(overallTotal)}</td></tr>`;

        html += `</table></body></html>`;

        const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = excludeZero
            ? `due_list_styled_excl_zero_${moment().format('YYYY-MM-DD')}.xls`
            : `due_list_styled_${moment().format('YYYY-MM-DD')}.xls`;
        a.click();
        URL.revokeObjectURL(url);
        toast.success('Excel (styled) exported successfully!');
    };

    return (
        <>
            <div className="container-fluid px-0">
                <Toaster position="top-right" reverseOrder={false} />

                <div className="row mt-3 px-4">
                    <div className="col-md-2 text-end" style={{ position: 'relative' }} ref={classDropdownRef}>
                        <div
                            className="form-control d-flex align-items-center justify-content-between"
                            style={{ cursor: 'pointer', minHeight: '38px', fontSize: '0.85rem' }}
                            onClick={() => setShowClassDropdown((prev) => !prev)}
                        >
                            <span className="text-truncate text-start">
                                {selectedClassStud.length === 0
                                    ? 'Select Class'
                                    : selectedClassStud.length === classOptionsForYear.length && classOptionsForYear.length > 0
                                        ? 'All Class'
                                        : `${selectedClassStud.length} class(es)`}
                            </span>
                            <i className={`fas fa-chevron-${showClassDropdown ? 'up' : 'down'} ms-2`} style={{ fontSize: '0.7rem' }}></i>
                        </div>
                        {showClassDropdown && (
                            <div style={{
                                position: 'absolute', top: '100%', left: '12px', right: '12px',
                                zIndex: 1050, background: '#fff', border: '1px solid #dee2e6',
                                borderRadius: '0 0 6px 6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                maxHeight: '220px', overflowY: 'auto', textAlign: 'left'
                            }}>
                                <div
                                    className="px-3 py-2 border-bottom"
                                    style={{ cursor: 'pointer', background: '#f8f9fa', fontSize: '0.82rem' }}
                                    onClick={handleSelectAllClasses}
                                >
                                    <input
                                        type="checkbox"
                                        checked={classOptionsForYear.length > 0 && selectedClassStud.length === classOptionsForYear.length}
                                        readOnly
                                        className="form-check-input me-2"
                                        style={{ marginTop: '2px' }}
                                    />
                                    <strong>Select All</strong>
                                </div>
                                {classOptionsForYear.map((option, index) => (
                                    <div
                                        key={option.id || option.class_name || index}
                                        className="px-3 py-2"
                                        style={{ cursor: 'pointer', fontSize: '0.82rem' }}
                                        onClick={() => handleToggleClass(option.class_name)}
                                        onMouseEnter={(e) => { e.currentTarget.style.background = '#e9ecef'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedClassStud.includes(option.class_name)}
                                            readOnly
                                            className="form-check-input me-2"
                                            style={{ marginTop: '2px' }}
                                        />
                                        {option.class_name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="col-md-1  text-end">
                        <select onChange={handleSelectChangeDev} className="form-control">
                            <option value=""> Div</option>
                            {stDev.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2 text-end" style={{ position: 'relative' }} ref={yearDropdownRef}>
                        <div
                            className="form-control d-flex align-items-center justify-content-between border border-danger"
                            style={{ cursor: 'pointer', minHeight: '38px', fontSize: '0.85rem' }}
                            onClick={() => setShowYearDropdown((prev) => !prev)}
                        >
                            <span className="text-truncate text-start">
                                {selectedDevYears.length === 0
                                    ? 'Year (All)'
                                    : selectedDevYears.length === stYear.length
                                        ? 'All Years'
                                        : `${selectedDevYears.length} year(s)`}
                            </span>
                            <i className={`fas fa-chevron-${showYearDropdown ? 'up' : 'down'} ms-2`} style={{ fontSize: '0.7rem' }}></i>
                        </div>
                        {showYearDropdown && (
                            <div style={{
                                position: 'absolute', top: '100%', left: '12px', right: '12px',
                                zIndex: 1050, background: '#fff', border: '1px solid #dee2e6',
                                borderRadius: '0 0 6px 6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                maxHeight: '220px', overflowY: 'auto', textAlign: 'left'
                            }}>
                                <div
                                    className="px-3 py-2 border-bottom"
                                    style={{ cursor: 'pointer', background: '#f8f9fa', fontSize: '0.82rem' }}
                                    onClick={handleSelectAllYears}
                                >
                                    <input
                                        type="checkbox"
                                        checked={stYear.length > 0 && selectedDevYears.length === stYear.length}
                                        readOnly
                                        className="form-check-input me-2"
                                        style={{ marginTop: '2px' }}
                                    />
                                    <strong>Select All</strong>
                                </div>
                                {stYear.map((option) => (
                                    <div
                                        key={option.id || option.name}
                                        className="px-3 py-2"
                                        style={{ cursor: 'pointer', fontSize: '0.82rem' }}
                                        onClick={() => handleToggleYear(option.name)}
                                        onMouseEnter={(e) => { e.currentTarget.style.background = '#e9ecef'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedDevYears.includes(option.name)}
                                            readOnly
                                            className="form-check-input me-2"
                                            style={{ marginTop: '2px' }}
                                        />
                                        {option.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={handleChangeDate} />
                    </div>
                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={handleChangeDateEnd}></input>
                    </div>
                    <div className="col-md-3">
                        <Select
                            options={options}
                            onChange={handleSelectChange}
                            value={selectedStud} // Set the selected value
                        />
                    </div>
                </div>

                <div className="row mt-3 px-4">
                    <div className="col-md-2">
                        <select onChange={handleSelectChangeStdType} className="form-control">
                            <option value="">Select Type</option>
                            <option value="New">New</option>
                            <option value="Old">Old</option>
                        </select>
                    </div>

                    <div className="col-md-3" style={{ position: 'relative' }} ref={feesDropdownRef}>
                        <div
                            className="form-control d-flex align-items-center justify-content-between"
                            style={{ cursor: 'pointer', minHeight: '38px', fontSize: '0.85rem' }}
                            onClick={() => setShowFeesDropdown(prev => !prev)}
                        >
                            <span className="text-truncate">
                                {selectedDevStudType.length === 0
                                    ? 'Fees Type'
                                    : selectedDevStudType.length === fees.length
                                        ? 'All Fees Types'
                                        : `${selectedDevStudType.length} selected`}
                            </span>
                            <i className={`fas fa-chevron-${showFeesDropdown ? 'up' : 'down'} ms-2`} style={{ fontSize: '0.7rem' }}></i>
                        </div>
                        {showFeesDropdown && (
                            <div style={{
                                position: 'absolute', top: '100%', left: '12px', right: '12px',
                                zIndex: 1050, background: '#fff', border: '1px solid #dee2e6',
                                borderRadius: '0 0 6px 6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                maxHeight: '220px', overflowY: 'auto'
                            }}>
                                <div
                                    className="px-3 py-2 border-bottom"
                                    style={{ cursor: 'pointer', background: '#f8f9fa', fontSize: '0.82rem' }}
                                    onClick={handleSelectAllFeeTypes}
                                >
                                    <input
                                        type="checkbox"
                                        checked={fees.length > 0 && selectedDevStudType.length === fees.length}
                                        readOnly
                                        className="form-check-input me-2"
                                        style={{ marginTop: '2px' }}
                                    />
                                    <strong>Select All</strong>
                                </div>
                                {fees.map((option) => (
                                    <div
                                        key={option.id}
                                        className="px-3 py-2"
                                        style={{ cursor: 'pointer', fontSize: '0.82rem' }}
                                        onClick={() => handleToggleFeeType(String(option.id))}
                                        onMouseEnter={e => e.currentTarget.style.background = '#e9ecef'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedDevStudType.includes(String(option.id))}
                                            readOnly
                                            className="form-check-input me-2"
                                            style={{ marginTop: '2px' }}
                                        />
                                        {option.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="col-md-3">
                        <select
                            onChange={handleSelectChangeAgentType}
                            className="form-control"
                        >
                            <option value="">Select Agent</option>
                            {stAgent.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row mt-3 mb-2 align-items-center px-4">
                    <div className="col-md-8 d-flex gap-2">
                        <Link to="/fees_item" className="btn btn-sm btn-outline-secondary" onClick={handleClearFields}>
                            Clear
                        </Link>

                        <button className="btn btn-sm btn-success" onClick={convertToExcel}>
                            <i className="fas fa-download me-1"></i>Export
                        </button>

                        <button className="btn btn-sm btn-danger" onClick={convertToPDF} title="Export PDF with all records">
                            <i className="fas fa-file-pdf me-1"></i>PDF
                        </button>

                        <button className="btn btn-sm btn-warning" onClick={convertToPDFExcludeZero} title="Export PDF excluding zero due">
                            <i className="fas fa-file-pdf me-1"></i>PDF (Excl. ₹0)
                        </button>

                        <button className="btn btn-sm btn-info text-white" onClick={() => convertToExcelStyled(false)} title="Export styled Excel (same as PDF layout)">
                            <i className="fas fa-file-excel me-1"></i>Excel (PDF)
                        </button>

                        <button className="btn btn-sm btn-primary" onClick={handleFilter}>
                            <i className="fas fa-search me-1"></i>Search
                        </button>
                    </div>

                    <div className="col-md-4 text-end d-flex gap-2 justify-content-end">
                        <Link to="/due_summary" className="btn btn-sm btn-outline-primary" title="View Due Summary">
                            <i className="fas fa-chart-bar me-1"></i>Summary
                        </Link>
                        <Link to="/paid_detail" className="btn btn-sm btn-outline-success" title="View Paid Fee Details">
                            <i className="fas fa-money-check-alt me-1"></i>Paid Details
                        </Link>
                    </div>
                </div>
                <hr className="mx-4" />
                <div className="row px-4">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : selectedClassStud.length === 0 && tasks.length === 0 ? (
                        <div className="alert alert-warning" role="alert">
                            Please select a class to filter!
                        </div>
                    ) : (
                        <div className="table-responsive">
                        <table id="printableTable" className="table table-striped center_tbl mt-2">
                            <thead className="table-primary">
                                <tr>
                                    <th style={{ width: '3%' }}>No</th>
                                    <th style={{ width: '7%' }}>Adm No</th>
                                    <th style={{ width: '12%' }}>Student Name</th>
                                    <th style={{ width: '12%' }}>Class</th>
                                    <th style={{ width: '5%' }}>Div</th>
                                    <th style={{ width: '10%' }}>Fee Type</th>
                                    <th style={{ width: '5%' }}>Type</th>
                                    <th style={{ width: '8%' }}>Master <br />(<b>{formatNumber(totalSumMaster)}</b>)</th>
                                    <th style={{ width: '8%' }}>Paid <br />(<b>{formatNumber(totalSumPaid)}</b>)</th>
                                    <th style={{ width: '8%' }}>Due <br />(<b>{formatNumber(totalSum)}</b>)</th>
                                    <th style={{ width: '7%' }}>Conslt</th>
                                    {/* <th style={{ width: '8%' }}>CONSLT Paid</th>
                                    <th style={{ width: '8%' }}>CONSLT Demand</th>
                                    <th style={{ width: '7%' }}>Balance</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((task, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{task.admn_no}</td>
                                        <td>
                                            {task.first_name} {task.last_name}
                                            {/* {task.id && (
                                                <Link 
                                                    to={`/bill_list/${task.id}`}
                                                    className="ms-2"
                                                    title="View Bills"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <i className="fas fa-link text-primary"></i>
                                                </Link>
                                            )} */}
                                            {isFromAgentReport && task.student_data && task.student_data.ext_11 && (
                                                <Link 
                                                    to="/student_list_all"
                                                    state={{ agentName: task.student_data.ext_11 }}
                                                    className="ms-2"
                                                    title="View Students for this Agent"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <i className="fas fa-link text-info"></i>
                                                </Link>
                                            )}
                                        </td>
                                        <td>{task.class}</td>
                                        <td>{task.dev}</td>
                                        <td>{task.fees_name ? task.fees_name.name : ""}</td>
                                        <td>{task.std_type}</td>
                                        <td><b>{formatNumber(task.amount)}</b></td>
                                        <td><b>{formatNumber(task.ext_6)}</b></td>
                                        <td><b>{formatNumber(calculateDue(task.amount, task.ext_6))}</b></td>
                                        <td><b>{task.student_data ? task.student_data.ext_11 : ""}</b></td>
                                        {/* <td><b>{formatNumber(task.agent_amount)}</b></td>
                                        <td><b>{formatNumber(task.student_data && task.student_data.ext_17 ? task.student_data.ext_17 : '')}</b></td>
                                        <td><b>{formatNumber((parseFloat(task.student_data && task.student_data.ext_17 ? task.student_data.ext_17 : 0) || 0) - (parseFloat(task.agent_amount) || 0))}</b></td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}
                </div>


            </div >
        </>
    );
}
